if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
                this.quickViewController?.abort();
        window.clearTimeout(this.quickViewLoadedTimer);

        const drawerContent = this.querySelector(this.selector);

        if (drawerContent) {
          drawerContent.innerHTML = '';
        }

        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

            quickview() {
        this.quickViewController?.abort();
        window.clearTimeout(this.quickViewLoadedTimer);

        const controller = new AbortController();
        this.quickViewController = controller;

        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const productUrl = this.dataset.productUrl;

        if (!drawerContent || !productUrl || !sectionId) {
          return;
        }

        const sectionUrl = new URL(
          productUrl,
          window.location.origin
        );

        sectionUrl.search = '';
        sectionUrl.searchParams.set('section_id', sectionId);

        fetch(sectionUrl.toString(), {
          cache: 'no-store',
          credentials: 'same-origin',
          signal: controller.signal,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                'Impossibile caricare la quick view'
              );
            }

            return response.text();
          })
          .then((responseText) => {
            if (
              controller.signal.aborted ||
              this.quickViewController !== controller ||
              !this.isConnected ||
              this.dataset.productUrl !== productUrl ||
              !this.contains(drawerContent)
            ) {
              return;
            }

            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            if (!(productElement instanceof HTMLTemplateElement)) {
              throw new Error(
                'Contenuto della quick view non trovato'
              );
            }

            this.setInnerHTML(
              drawerContent,
              productElement.content.cloneNode(true)
            );

            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            this.quickViewLoadedTimer = window.setTimeout(() => {
              if (
                !controller.signal.aborted &&
                this.quickViewController === controller &&
                this.isConnected
              ) {
                this.classList.add(this._classes.loaded);
              }
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl },
              })
            );
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.error(error);
            }
          });
      }


      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

            disconnectedCallback() {
        super.disconnectedCallback();

        queueMicrotask(() => {
          if (!this.isConnected) {
            this.handleAfterHide();
          }
        });
      }

    }
  );
}
